import React, {PureComponent} from "react";
import {reduxForm, formValueSelector} from "redux-form";
import ModalButton from "../../../../core/components/modals/ModalButton";
import UploadedFilesList from "./inc/UploadedFilesList";
import FileButton from "../../buttons/FileButton";
import UrlButton from "../../buttons/UrlButton";
import OrderInfo from "./inc/OrderInfo";
import {FILE_STATUS_UPLOADED, FILE_STATUS_UPLOADING} from "../../../../core/constants/FileStatusConstant";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import FormSubmitButton from "../../buttons/FormSubmitButton";
import {scrollToFirstError} from '../../helpers/ScrollToFirstErrorHelper'

class OrderFormFilesPage extends PureComponent {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.updateFilesField();
    }

    updateFilesField = () => {
        const {files, filesAttribute: oldFilesValue, change, touch, untouch} = this.props;

        const uploadingItems = files.filter(item => item.status === FILE_STATUS_UPLOADING);
        if (uploadingItems.length) {
            untouch('files');
            return;
        }

        const uploadedItems = files.filter(item => item.status === FILE_STATUS_UPLOADED);
        const newFilesValue = uploadedItems.length || undefined;

        if (oldFilesValue !== newFilesValue) {
            change('files', newFilesValue);
        }

        touch('files');
    };

    render() {
        const { handleSubmit, t } = this.props;

        return <div className="main">
            <h1>{t('Order transcriptions')}</h1>
            <span className="info">{t('Professionals transcribe your files to 99% accuracy')}</span>
            <div className="main-holder inner">
                <div className="content">
                    <div className="block">
                        <form onSubmit={handleSubmit} className="files-list-form">
                            <UploadedFilesList />
                        </form>

                        <div className="bottom-panel mobile-hidden">
                            <ModalButton id="file-modal-component" className="upload">
                                {t('UPLOAD MORE FILES')}
                            </ModalButton>
                            <span className="or">{t('Or')}</span>
                            <ModalButton id="url-modal-component" className="more-url">
                                {t('ADD MORE URL')}
                            </ModalButton>
                        </div>
                        <div className="mobile-visible">
                            <div className="bottom-panel">
                                <FileButton className="upload">{t('UPLOAD FILES')}</FileButton>
                                <span className="or">{t('Or')}</span>
                                <UrlButton className="more-url">{t('ADD URL')}</UrlButton>
                            </div>
                        </div>
                    </div>
                </div>
                <aside id="sidebar">
                    <OrderInfo />
                </aside>
            </div>
            <div className="btn-holder line">
                <FormSubmitButton formName="OrderForm" className="btn pink checkout-button">
                    {t('CHECKOUT')}
                </FormSubmitButton>
            </div>
        </div>
    }
}

OrderFormFilesPage = withTranslation()(OrderFormFilesPage);

OrderFormFilesPage = reduxForm({
    form: 'OrderForm',
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    onSubmitFail: (errors) => scrollToFirstError(errors),
})(OrderFormFilesPage)

const selector = formValueSelector('OrderForm');

export default connect(
    state => ({
        files: state.file.files,
        filesAttribute: selector(state, 'files'),
    })
)(OrderFormFilesPage);